var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabaseLight1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "database-light 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50 97.29C76.1175 97.29 97.29 76.1175 97.29 50C97.29 23.8824 76.1175 2.70996 50 2.70996C23.8824 2.70996 2.70996 23.8824 2.70996 50C2.70996 76.1175 23.8824 97.29 50 97.29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M57.83 32.3203H5.5V45.9803H57.83V32.3203Z",
    fill: "#C9F2DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M94.4997 49.3701H63.2197V62.5001H94.4997V49.3701Z",
    fill: "#C9F2DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M94.4997 65.9102H63.2197V79.0402H94.4997V65.9102Z",
    fill: "#C9F2DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.8301 35.21H8.33008V39.15H15.8301V35.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M28.3301 35.21H20.8301V39.15H28.3301V35.21Z",
    fill: "#00B76D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M57.83 16H5.5V29.66H57.83V16Z",
    fill: "#C9F2DE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M57.83 48.8398H5.5V62.4998H57.83V48.8398Z",
    fill: "#C9F2DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M58.58 63.2596H4.75V48.0996H58.58V63.2596ZM6.25 61.7596H57.08V49.5996H6.25V61.7596Z",
    fill: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M54.5801 18.8301H47.0801V22.7701H54.5801V18.8301Z",
    fill: "#00B76D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M42.0801 18.8301H34.5801V22.7701H42.0801V18.8301Z",
    fill: "#0B3F30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M58.58 30.41H4.75V15.25H58.58V30.41ZM6.25 28.91H57.08V16.75H6.25V28.91Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M58.58 46.7401H4.75V31.5801H58.58V46.7401ZM6.25 45.2401H57.08V33.0801H6.25V45.2401Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M58.58 63.2596H4.75V48.0996H58.58V63.2596ZM6.25 61.7596H57.08V49.5996H6.25V61.7596Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M95.2499 63.2596H61.9199V48.0996H95.2499V63.2596ZM63.4199 61.7596H93.7499V49.5996H63.4199V61.7596Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M95.2499 79.7703H61.9199V64.6104H95.2499V79.7703ZM63.4199 78.2703H93.7499V66.1104H63.4199V78.2703Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M42.5801 23.2701H34.0801V18.3301H42.5801V23.2701ZM35.0801 22.2701H41.5801V19.3301H35.0801V22.2701Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M55.0801 23.2701H46.5801V18.3301H55.0801V23.2701ZM47.5801 22.2701H54.0801V19.3301H47.5801V22.2701Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M16.3301 39.6597H7.83008V34.7197H16.3301V39.6597ZM8.83008 38.6597H15.3301V35.7197H8.83008V38.6597Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M28.8301 39.6597H20.3301V34.7197H28.8301V39.6597ZM21.3301 38.6597H27.8301V35.7197H21.3301V38.6597Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M64.1699 23.5195H60.6699C60.2599 23.5195 59.9199 23.1795 59.9199 22.7695C59.9199 22.3595 60.2599 22.0195 60.6699 22.0195H64.1699C64.5799 22.0195 64.9199 22.3595 64.9199 22.7695C64.9199 23.1795 64.5799 23.5195 64.1699 23.5195Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M73.5 27.0195C73.09 27.0195 72.75 26.6795 72.75 26.2695V23.5195H70C69.59 23.5195 69.25 23.1795 69.25 22.7695C69.25 22.3595 69.59 22.0195 70 22.0195H74.25V26.2695C74.25 26.6795 73.91 27.0195 73.5 27.0195Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M73.5 38.9098C73.09 38.9098 72.75 38.5698 72.75 38.1598V30.5898C72.75 30.1798 73.09 29.8398 73.5 29.8398C73.91 29.8398 74.25 30.1798 74.25 30.5898V38.1598C74.25 38.5698 73.91 38.9098 73.5 38.9098Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M73.5 46.7393C73.09 46.7393 72.75 46.3993 72.75 45.9893V42.4893C72.75 42.0793 73.09 41.7393 73.5 41.7393C73.91 41.7393 74.25 42.0793 74.25 42.4893V45.9893C74.25 46.3993 73.91 46.7393 73.5 46.7393Z",
    fill: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M81.0801 30.4102H78.5801C78.1701 30.4102 77.8301 30.0702 77.8301 29.6602C77.8301 29.2502 78.1701 28.9102 78.5801 28.9102H81.0801C81.4901 28.9102 81.8301 29.2502 81.8301 29.6602C81.8301 30.0702 81.4901 30.4102 81.0801 30.4102Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M83.8301 32.9102C83.4201 32.9102 83.0801 32.5702 83.0801 32.1602V30.4102H81.3301C80.9201 30.4102 80.5801 30.0702 80.5801 29.6602C80.5801 29.2502 80.9201 28.9102 81.3301 28.9102H84.5801V32.1602C84.5801 32.5702 84.2401 32.9102 83.8301 32.9102Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M83.8301 40.2402C83.4201 40.2402 83.0801 39.9002 83.0801 39.4902V36.1602C83.0801 35.7502 83.4201 35.4102 83.8301 35.4102C84.2401 35.4102 84.5801 35.7502 84.5801 36.1602V39.4902C84.5801 39.9002 84.2401 40.2402 83.8301 40.2402Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M83.8301 46.7402C83.4201 46.7402 83.0801 46.4002 83.0801 45.9902V43.4902C83.0801 43.0802 83.4201 42.7402 83.8301 42.7402C84.2401 42.7402 84.5801 43.0802 84.5801 43.4902V45.9902C84.5801 46.4002 84.2401 46.7402 83.8301 46.7402Z",
    fill: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M31.8301 72.9402H27.5801V66.1602C27.5801 65.7502 27.9201 65.4102 28.3301 65.4102C28.7401 65.4102 29.0801 65.7502 29.0801 66.1602V71.4402H31.8301C32.2401 71.4402 32.5801 71.7802 32.5801 72.1902C32.5801 72.6002 32.2401 72.9402 31.8301 72.9402Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M46.8301 72.9404H39.3301C38.9201 72.9404 38.5801 72.6004 38.5801 72.1904C38.5801 71.7804 38.9201 71.4404 39.3301 71.4404H46.8301C47.2401 71.4404 47.5801 71.7804 47.5801 72.1904C47.5801 72.6004 47.2401 72.9404 46.8301 72.9404Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M57.8301 72.9404H54.3301C53.9201 72.9404 53.5801 72.6004 53.5801 72.1904C53.5801 71.7804 53.9201 71.4404 54.3301 71.4404H57.8301C58.2401 71.4404 58.5801 71.7804 58.5801 72.1904C58.5801 72.6004 58.2401 72.9404 57.8301 72.9404Z",
    fill: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M43.0801 53.2796C42.8001 53.2796 42.5801 53.0596 42.5801 52.7796V48.8496C42.5801 48.5696 42.8001 48.3496 43.0801 48.3496C43.3601 48.3496 43.5801 48.5696 43.5801 48.8496V52.7796C43.5801 53.0596 43.3601 53.2796 43.0801 53.2796Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M47.0801 53.2796C46.8001 53.2796 46.5801 53.0596 46.5801 52.7796V48.8496C46.5801 48.5696 46.8001 48.3496 47.0801 48.3496C47.3601 48.3496 47.5801 48.5696 47.5801 48.8496V52.7796C47.5801 53.0596 47.3601 53.2796 47.0801 53.2796Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M50.9199 53.2796C50.6399 53.2796 50.4199 53.0596 50.4199 52.7796V48.8496C50.4199 48.5696 50.6399 48.3496 50.9199 48.3496C51.1999 48.3496 51.4199 48.5696 51.4199 48.8496V52.7796C51.4199 53.0596 51.1999 53.2796 50.9199 53.2796Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M43.1699 62.5101C42.8899 62.5101 42.6699 62.2901 42.6699 62.0101V58.0801C42.6699 57.8001 42.8899 57.5801 43.1699 57.5801C43.4499 57.5801 43.6699 57.8001 43.6699 58.0801V62.0101C43.6699 62.2901 43.4499 62.5101 43.1699 62.5101Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M47.1699 62.5101C46.8899 62.5101 46.6699 62.2901 46.6699 62.0101V58.0801C46.6699 57.8001 46.8899 57.5801 47.1699 57.5801C47.4499 57.5801 47.6699 57.8001 47.6699 58.0801V62.0101C47.6699 62.2901 47.4499 62.5101 47.1699 62.5101Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M51 62.5101C50.72 62.5101 50.5 62.2901 50.5 62.0101V58.0801C50.5 57.8001 50.72 57.5801 51 57.5801C51.28 57.5801 51.5 57.8001 51.5 58.0801V62.0101C51.5 62.2901 51.28 62.5101 51 62.5101Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M67.0795 77.0702C65.9495 77.0702 65.0195 76.1502 65.0195 75.0102C65.0195 73.8702 65.9395 72.9502 67.0795 72.9502C68.2195 72.9502 69.1395 73.8702 69.1395 75.0102C69.1395 76.1502 68.2195 77.0702 67.0795 77.0702ZM67.0795 73.9602C66.4995 73.9602 66.0195 74.4302 66.0195 75.0202C66.0195 75.6102 66.4895 76.0802 67.0795 76.0802C67.6695 76.0802 68.1395 75.6102 68.1395 75.0202C68.1395 74.4302 67.6695 73.9602 67.0795 73.9602Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M90.9399 56.8297C89.8099 56.8297 88.8799 55.9097 88.8799 54.7697C88.8799 53.6297 89.7999 52.7197 90.9399 52.7197C92.0799 52.7197 92.9999 53.6397 92.9999 54.7697C92.9999 55.8997 92.0799 56.8297 90.9399 56.8297ZM90.9399 53.7197C90.3599 53.7197 89.8799 54.1897 89.8799 54.7697C89.8799 55.3497 90.3499 55.8297 90.9399 55.8297C91.5299 55.8297 91.9999 55.3597 91.9999 54.7697C91.9999 54.1797 91.5299 53.7197 90.9399 53.7197Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M76.06 79.52C75.78 79.52 75.56 79.3 75.56 79.02V73.96H72V79.02C72 79.3 71.78 79.52 71.5 79.52C71.22 79.52 71 79.3 71 79.02V72.96H76.56V79.02C76.56 79.3 76.34 79.52 76.06 79.52Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M85.3902 56.2198C86.1855 56.2198 86.8302 55.5751 86.8302 54.7798C86.8302 53.9846 86.1855 53.3398 85.3902 53.3398C84.5949 53.3398 83.9502 53.9846 83.9502 54.7798C83.9502 55.5751 84.5949 56.2198 85.3902 56.2198Z",
    fill: "#00B76D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M85.3901 56.8297C84.2601 56.8297 83.3301 55.9097 83.3301 54.7697C83.3301 53.6297 84.2501 52.7197 85.3901 52.7197C86.5301 52.7197 87.4501 53.6397 87.4501 54.7697C87.4501 55.8997 86.5301 56.8297 85.3901 56.8297ZM85.3901 53.7197C84.8101 53.7197 84.3301 54.1897 84.3301 54.7697C84.3301 55.3497 84.8001 55.8297 85.3901 55.8297C85.9801 55.8297 86.4501 55.3597 86.4501 54.7697C86.4501 54.1797 85.9801 53.7197 85.3901 53.7197Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M73.78 73.96H72V78.25H73.78V73.96Z",
    fill: "#0B3F30"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M9.42 16.75H6.25V28.91H9.42V16.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M66.5899 49.5898H63.4199V61.7498H66.5899V49.5898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M93.5899 66.1104H90.4199V78.2703H93.5899V66.1104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M9.42 49.5898H6.25V61.7498H9.42V49.5898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M57.0899 33.0703H53.9199V45.2303H57.0899V33.0703Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseLight1);
export default __webpack_public_path__ + "static/media/database-light1.522c43841f155443d60823198e023001.svg";
export { ForwardRef as ReactComponent };